


















// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
import { VRadio } from 'vuetify/lib'; // Correct way to import Vuetify component
import Vue from 'vue';
export default Vue.extend({
    name: 'BaseRadio',
    components: {
        VRadio
    },
    props: {
        onIconProp: {
            type: String,
            default: 'mdi-check-circle'
        },
        offIconProp: {
            type: String,
            default: 'mdi-circle-outline'
        }
    },
    computed: {
        onIcon(): string | undefined {
            return this.onIconProp;
        },
        offIcon(): string | undefined {
            return this.offIconProp;
        }
    }
});
